import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
export interface StatusStruct {
  signerFullName: string
  signerAvatar?: string
  description?: string
  statusText?: string
  statusDate?: string
  statusDescription?: string
}

export interface Props {
  status: StatusStruct
  statusBox: React.ReactElement
}

const formatStatusText = (status: string, dateString: string) => {
  const date = moment(dateString).format('ll')

  return i18n.t('documents.modal.esignature.status_date', { status, date })
}

const StatusItem = ({ status, statusBox }: Props) => {
  const { signerFullName, signerAvatar, description, statusText, statusDate, statusDescription } =
    status
  const showStatusText = statusText && statusDate

  return (
    <Box
      component="li"
      padding="s16"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      className={'StatusItem_listItem'}
      border={{}}
    >
      <Box flexGrow>
        <Box flexDirection="row">
          <Box alignItems="center" flexGrow flexDirection="row" gap="s12">
            <Avatar size="s40" url={buildUrl(signerAvatar)} label={signerFullName} />
            <Box gap="s4">
              <Text size="200" weight="medium" color="grey1000" overflowWrap>
                {signerFullName}
              </Text>
              {showStatusText && (
                <Text size="100" color="grey1000" overflowWrap>
                  {formatStatusText(statusText, statusDate)}
                </Text>
              )}
              {statusDescription && (
                <Text size="100" color="grey1000" overflowWrap>
                  {statusDescription}
                </Text>
              )}
            </Box>
          </Box>
          <Box flexDirection="row" justifyContent="flexEnd">
            <Box alignSelf="center">{statusBox}</Box>
          </Box>
        </Box>
        {description && (
          <Box paddingTop="s12">
            <Text size="100" color="grey1000" overflowWrap>
              &quot;{description}&quot;
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default StatusItem
